import { useEffect, useState } from 'react'
import OrderService from '../../../../../services/UiService/Order'
import { useParams } from 'react-router'
import { OrderModel } from '../../../../../models/New/Order'
import { arraySort } from '../../../../../utils/helpers'
import OrderListTable from '../../../../../components/OrderTableList'
import { toast } from 'react-toastify'
import Loading from '../../../../../components/Loading'

interface Props {
    visible: boolean
    filteredOrders: OrderModel[]
    onSearch: (data: OrderModel[]) => void
    setOrders: (data: OrderModel[]) => void
}

const OrderTab = (props: Props) => {
    const { productId } = useParams()
    const [loading, setLoading] = useState<boolean>(false)
    const getOrders = async () => {
        try {
            setLoading(true)
            const response = await OrderService.getOrderByProductId(productId!)
            props.setOrders(arraySort(response, 'creationDate', 'descending'))
        } catch (error: any) {
            toast.error(error)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (props.visible) getOrders()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.visible])

    return (
        <div
            style={{
                display: props.visible ? 'flex' : 'none',
                flexDirection: 'column',
                gap: '1rem',
            }}
        >
            {loading && <Loading />}
            <OrderListTable data={props.filteredOrders} />
        </div>
    )
}

export default OrderTab
